import { ReactNode } from 'react';
import ButtonGroup from '@/creditflowresearch/ui/common/components/organisms/ButtonGroup';
import FilterSetGroup from '@/creditflowresearch/ui/common/components/organisms/FilterSetGroup';
import type { IFilterButton } from '@/creditflowresearch/ui/common/components/organisms/ButtonGroup';
import { IFilterButtonSet } from '@/creditflowresearch/ui/common/hooks/filters/useFilterButtons';

interface IPageTopSectionItemsProps {
  items: IFilterButtonSet[] | IFilterButton[] | ReactNode,
  onClick?: (item: IFilterButton) => void,
}

const isFilterButtonSet = (item: IFilterButtonSet | IFilterButton): item is IFilterButtonSet => {
  return 'key' in item && 'items' in item && Array.isArray(item.items);
};

const PageTopSectionItems = ({ items, onClick }: IPageTopSectionItemsProps) => {
  if (!Array.isArray(items)) {
    return <>{ items }</>;
  }

  if (items.length === 0) {
    return null;
  }

  const firstItem = items[0];
  const isFilterSet = isFilterButtonSet(firstItem);

  if (isFilterSet) {
    return <FilterSetGroup filterSets={ items as IFilterButtonSet[] } onClick={ onClick } />;
  }

  return <ButtonGroup items={ items as IFilterButton[] } onClick={ onClick } />;
};

export default PageTopSectionItems;
